import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  UpdateOwnFinancialLimitDto,
  UpdateOwnFinancialLimitEntity,
  UserWalletManageService,
} from 'services/openapi';

import { UserServiceQueryKeys } from '../constants';

export const useUpdateOwnFinancialLimitsMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      UpdateOwnFinancialLimitEntity,
      Error,
      UpdateOwnFinancialLimitDto
    >({
      mutationFn: (variables: UpdateOwnFinancialLimitDto) => {
        return UserWalletManageService.userManageControllerUpdateOwnFinancialLimits(
          variables,
        );
      },
      onSuccess: () =>
        Promise.all([
          queryClient.invalidateQueries([
            UserServiceQueryKeys.GET_USER_PROFILE,
          ]),
        ]),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
